import * as THREE from "three"
import Experience from "../Experience.js"

export default class Floor {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.canvas = this.experience.canvas
        this.debug = this.experience.debug

        this.setGeometry()
        this.setMaterial()
        this.setMesh()
    }

    setGeometry() {
        this.planeGeometry = new THREE.PlaneGeometry(20000, 20000)
            // this.cylindreGeometry = new THREE.CylinderGeometry(1, 1, 50, 3200)
    }

    setMaterial() {
        const texture = new THREE.TextureLoader().load(
            "map/map_alpha_indicator.jpg"
        )

        this.material = new THREE.MeshStandardMaterial({
            color: 0xffffff
        })
    }

    setMesh() {
        this.floor = new THREE.Mesh(this.planeGeometry, this.material)

        this.floor.material.side = 2
        this.floor.rotation.x = -Math.PI * 0.5
        this.floor.position.y = -2.4

        this.scene.add(this.floor)
    }
}